import { useEffect } from "react";
import "@saas2/react-ui/dist/es/style.css";
import {
  init as sentryInit,
  withProfiler as sentryWithProfiler,
  wrapUseRoutes,
  setUser as reportUserInfo,
  reactRouterV6Instrumentation,
  addBreadcrumb,
} from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ThemeProvider from "theme";
import DialogProvider from "providers/DialogProvider";
import App from "screens/App";
import { RecoilEnv, useSetRecoilState } from "recoil";
import { getUserInfo, getUserPreference } from "./api/common";
import { getIsTrader } from "api/trigger";
import FallbackPage from "components/common/FallbackPage";
import "assets/iconfont/iconfont.css";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
  useRoutes,
} from "react-router-dom";
import "./index.less"; // 唯一的根公用css
import "rc-dropdown/assets/index.css";
import "./assets/iconfont/iconfont.css";
import "./tailwind.css";
import "rc-drawer/assets/index.css";
RecoilEnv.RECOIL_GKS_ENABLED.delete("recoil_hamt_2020");
RecoilEnv.RECOIL_GKS_ENABLED.delete("recoil_memory_managament_2020");
import {
  UserState,
  transferUserInfo,
  isTraderState,
  UserPreferenceSettingState,
  UserFullInfoState,
  UserPreferenceSettingEnum,
  UserSimulationFlagState,
} from "./store/data/User";

//sdk埋点
import logEvent from "hooks/logEvent";
import LocalCache, { CacheKey } from "./util/LocalCache";
import { isSuccess } from "util/Common";
import { GlobalRouterConfig } from "./screens/GlobalRouterConfig";
import { isBrowserEnv } from "@app/utils/constants";
import loadable from "@app/utils/loadable";
import { Last24HOption } from "./constants/base";
import isNil from "lodash-es/isNil";
import { localForage, Business } from "@saas2/utils";
// import useInitFastestImageDomain from "hooks/useInitFastestImageDomain";
import { message } from "@bit-design/react";
import { captureBusinessException } from "./util/sentry/captureBusinessException";
import { isCurrentTabState } from "./store/data/Common";

message.config({
  "data-testid": "TradeCommonToastText",
});

const RecoilDebug = loadable(() => import("components/common/RecoilDebug"), {
  ssr: false,
});
const ErrorCheck = loadable(
  () => import("components/common/ErrorBoundary/ErrorCheck"),
  {
    ssr: false,
  }
);

const env = process.env.REACT_APP_ENV;
const projectId = 9;

if (isBrowserEnv) {
  localForage.setBusiness(Business.MIX);
  // if (["beta", "online", "local"].includes(env)) {
    // sentryInit({
      /**
       * DSN（Data Source Name）是一个唯一标识符，用于帮助 Sentry 知道如何连接到哪里以及向哪里发送错误报告。
       * 它通常包含了协议、密钥、Sentry 服务的 URL 等信息。
       * 当你在 Sentry 上创建一个新的项目时，会生成一个与之对应的 DSN。
       * 这个 DSN 需要被添加到你的应用代码中，以便初始化 Sentry。
       * */
      // dsn: `https://8aeef93d782e4ef5ae75634bfee9b590@${window.location.host}/v1/sentry/${projectId}`,
      // environment: env,
      // 不指定应该会默认使用commitID
      // release: process.env.SENTRY_RELEASE,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      // tracesSampleRate: env === "online" ? 0.1 : 1, // 0.01,
      // beforeSend(event) {
      //   if (env === "local") {
      //     console.log("sentry event:", event);
      //     return null;
      //   } else {
      //     return event;
      //   }
      // },
      // sampleRate: 1,
      // transaction性能采样率
      // tracesSampler: (samplingContext) => {
        // const name = samplingContext?.transactionContext?.name;

        // 生产环境
        // if (env === "online") {
          // 网络请求采样率
          // if (/^(POST: |GET: ).*/.test(name)) {
          //   return 0.01;
          // } else {
          //   // 线上其他采样率
          //   return 0.02;
          // }
          // 本地环境添加日志
      //   } else if (env === "local") {
      //     if (!/^(POST: |GET: ).*/.test(name)) {
      //       console.log("sentry samplingContext:", samplingContext);
      //     }
      //     return 1.0;
      //   } else {
      //     return 1.0;
      //   }
      // },
      // all options you normally pass to Sentry.init
      // transport: makeFetchTransport,
      // stackParser: defaultStackParser,
      // Only the integrations listed here will be used
      // integrations: [
        // new BrowserTracing({
        //   routingInstrumentation: reactRouterV6Instrumentation(
        //     useEffect,
        //     useLocation,
        //     useNavigationType,
        //     createRoutesFromChildren,
        //     matchRoutes
        //   ),
        // }),
      // ],
    // });
  }

  // throw Error('test error 01/0')

  // window.stopDispatchMessage = false;
  // window.onbeforeunload = function () {
  //   window.stopDispatchMessage = true;
  // };
  /**
   * 防止Safari浏览器点击返回不刷新
   * @type {RegExp}
   */
  // const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/
  // if (browserRule.test(navigator.userAgent)) {
  //     window.onpageshow = function (e) {
  //         if (e.persisted || (window.performance && window.performance.navigation.type === 2)) {
  //             window.location.reload()
  //         }
  //     }
  // }
// }

function initDX() {
  // dxToken.init({
  //     // 是否为测试环境-默认false
  //     isTestEnv: /^(test|dev)/.test(process.env._ENV),
  //     // 顶象sdk_dx.ConstID的options，可选，按需配置
  //     options: { timeout: 5000 },
  //     // 上报error，有接入sentry就传，参考主站
  //     captureBusinessException,
  //     // 上报日志，有接入sentry就传，参考主站
  //     addBreadcrumb,
  //     // 非特殊不必传，使用默认配置即可，自动刷新token频率，默认1200，20分钟刷新一次
  //     dxFrequency: 1200,
  //     // 非特殊不必传，使用默认配置即可，过期时间间隔，默认4小时过期
  //     dxTokenExpireInterval: 4 * 60 * 60
  //     // 非特殊不必传，使用默认配置即可，默认值：webCommonConfig接口的dyTokenUrlList
  //     // 如果你需要dyToken的接口不在dyTokenUrlList里@jimmy li更新配置
  //     // dyTokenUrlList: ['/v1/user/login', '/v1/user/login/verify-login'...]
  // })
}

const Main = sentryWithProfiler(() => {
  const setUser = useSetRecoilState(UserState);
  const setFullUserInfo = useSetRecoilState(UserFullInfoState);
  const setUserTrader = useSetRecoilState(isTraderState);
  const initUserPreferenceState = useSetRecoilState(UserPreferenceSettingState);
  const setIsCurrentTab = useSetRecoilState(isCurrentTabState);
  const setSimulationFlag = useSetRecoilState(UserSimulationFlagState);

  const loginInGetData = async () => {
    // 是否包含已委托
    let [data, preferenceData] = await Promise.all([
      getIsTrader(),
      getUserPreference(),
    ]);
    initUserPreferenceState((oldConfig) =>
      Object.assign({}, oldConfig, { quantityIncludesDelegated: Number(true) })
    );
    // 该用户是否是交易员
    if (isSuccess(data?.code)) {
      setUserTrader(data.data.result);
    }

    if (isSuccess(preferenceData?.code) && preferenceData.data) {
      let timeZone = Last24HOption;
      if (
        !isNil(preferenceData.data.timeZone) &&
        preferenceData.data.timeZone !== "-1"
      ) {
        timeZone = (-preferenceData.data.timeZone / 60).toString();
      }
      initUserPreferenceState((oldConfig) =>
        Object.assign({}, oldConfig, {
          ...preferenceData.data,
          [UserPreferenceSettingEnum.BENCHMARK_TIMEZONE]: timeZone,
        })
      );
    }
  };

  const init = async () => {
    try {
      const res = await getUserInfo();
      // .then(res => {
      if (isSuccess(res?.code) && res.data) {
        reportUserInfo({
          id: res?.data?.userInfo?.userId,
          username: res?.data.userName,
        });
        setFullUserInfo(res.data);
        let fixedUserInfo = transferUserInfo(res.data);

        setUser((defaultUser) => Object.assign({}, defaultUser, fixedUserInfo));
        // pinTradingSwitch 选项初始化设置在偏好设置中
        initUserPreferenceState((oldConfig) =>
          Object.assign({}, oldConfig, {
            pinTradingSwitch: fixedUserInfo.pinTradingSwitch,
          })
        );
        //-----------------sdk埋点数据更新--------------
        if (res.data?.userInfo?.userId) {
          logEvent.update({ uid: res.data.userInfo.userId });
        }
        //-----------------------------------------
        await loginInGetData();
      } else {
        setSimulationFlag(false);
      }
    } catch (e) {
      setSimulationFlag(false);
      console.error("get user info error:", e);
    }

    // timezone 选项暂时没有保存在服务端，暂时需要从在localStorage
    initUserPreferenceState((oldConfig) =>
      Object.assign({}, oldConfig, {
        timezone: LocalCache.get(CacheKey.TIMEZONE),
      })
    );
  };

  useEffect(() => {
    init();

    if (isBrowserEnv) {
      // 顶像相关逻辑初始化
      if (window.isDXReady) {
        initDX();
      } else {
        window.dxReady = () => {
          initDX();
        };
      }
    }
  }, []);
  let timeoutHandler;

  useEffect(() => {
    const visibilityChangeHandler = () => {
      // let timeoutHandler
      if (document.visibilityState === "visible") {
        setIsCurrentTab(1);
        // timeoutHandler = setTimeout(() => {
        //     // debug用
        //     console.log('页面现在在当前标签页中1')
        //     setIsCurrentTab(1)
        // }, 1000)
      } else {
        setIsCurrentTab(0);
        // clearTimeout(timeoutHandler)
      }
    };
    // 监听页面是否在当前标签页中
    if (isBrowserEnv) {
      window.addEventListener("visibilitychange", visibilityChangeHandler);
    }
    return () => {
      if (isBrowserEnv) {
        window.removeEventListener("visibilitychange", visibilityChangeHandler);
      }
    };
  }, []);

  const useSentryRoutes = wrapUseRoutes(useRoutes);

  // useInitFastestImageDomain();

  function AppRouters() {
    return useSentryRoutes([
      {
        path: "/",
        element: (
          <ThemeProvider>
            <DialogProvider>
              <App />
            </DialogProvider>
          </ThemeProvider>
        ),
        errorElement: <FallbackPage />,
        children: GlobalRouterConfig,
      },
    ]);
  }

  return <AppRouters />;
});

export const TradeApp = () => {
  return (
    <>
      {env !== "online" && <RecoilDebug />}
      {<ErrorCheck />}
      <Main />
    </>
  );
};
